import { fetchUsage, fetchRepositories } from '../api';
const calculateUsage = ({ allowed, total, notificationThreshold }, repos, logger) => {
    const usage = {
        totalUsage: {
            allowed: Number(allowed.$),
            notificationThreshold: Number(notificationThreshold.$),
            total: Number(total.$),
        },
        trashUsage: 0,
    };
    const fields = [
        'imageUsage',
        'videoUsage',
        'musicUsage',
        'otherUsage',
    ];
    fields.forEach((field) => {
        usage[field] = { count: 0, usage: 0 };
    });
    const getUsageInfo = (obj, repoUsageValue, repoUsageCount) => (repoUsageCount ? obj.usage + repoUsageValue : obj.usage);
    (Array.isArray(repos) ? repos : [repos]).forEach((repository) => {
        // calculate counts
        usage.imageUsage.count += Number(repository.imageCount.$);
        usage.videoUsage.count += Number(repository.videoCount.$);
        usage.musicUsage.count += Number(repository.audioCount.$);
        // calculate usage
        usage.imageUsage.usage = getUsageInfo(usage.imageUsage, Number(repository.imageUsage.$), Number(repository.imageCount.$));
        usage.videoUsage.usage = getUsageInfo(usage.videoUsage, Number(repository.videoUsage.$), Number(repository.videoCount.$));
        usage.musicUsage.usage = getUsageInfo(usage.musicUsage, Number(repository.audioUsage.$), Number(repository.audioCount.$));
        if (repository.hasOwnProperty('trashUsage')) {
            usage.trashUsage += Number(repository.trashUsage.$);
        }
        // Skip "top level folder"
        let versionUsage = 0;
        if (repository.hasOwnProperty('versionUsage')) {
            versionUsage = Number(repository.versionUsage.$);
        }
        if (repository.documentUsage.$ !== '1024') {
            usage.otherUsage.count += Number(repository.documentCount.$);
            usage.otherUsage.usage =
                Number(versionUsage) +
                    getUsageInfo(usage.otherUsage, Number(repository.documentUsage.$), Number(repository.documentCount.$));
        }
    });
    return usage;
};
export default async (logger) => {
    // @ts-ignore
    const [{ usage }, { repositories: { repository }, },] = await Promise.all([fetchUsage(), fetchRepositories()]);
    return calculateUsage(usage, repository, logger);
};
